import SankeyChart from "./SankeyChart/SankeyChart";
import StackedBarChart from "./StackedBarChart/StackedBarChart";
import MyComposedChart from "./ComposedChart/ComposedChart";
import StockChart from "./StockChart/StockChart";
import CompoundInterestChart from "./CompoundInterestChart/CompoundInterestChart";
import LineChart from "./LineChart/LineChart";
import PieChart from "./PieChart/PieChart";
import SimpleBarChart from "./BarChart/BarChart";

const Charts = {
  Composed: MyComposedChart,
  Sankey: SankeyChart,
  StackedBar: StackedBarChart,
  Stock: StockChart,
  CompoundInterest: CompoundInterestChart,
  Line: LineChart,
  Pie: PieChart,
  SimpleBarChart: SimpleBarChart,
};

export default Charts;
